import { IController } from 'angular';
import * as _ from 'lodash';

export class ScheduleDialogCtrl implements IController {
  static $inject = ['$mdDialog', '$scope'];

  // Bindings
  private repeatIntervals;
  private frequencies;
  private initialScheduleValues;

  constructor(private $mdDialog, private $scope) {
    this.repeatIntervals = ['DAILY', 'EVERY WEEKDAY(M-F)', 'EVERY M/W/F', 'EVERY T/Th', 'WEEKLY', 'MONTHLY'];
    this.frequencies = [1, 2, 3, 4, 5];

    this.initialScheduleValues = {
      endTime: this.$scope.currentSupport.schedule.endTime,
      startTime: this.$scope.currentSupport.schedule.startTime,
      endsOn: this.$scope.currentSupport.schedule.endsOn,
      startsOn: this.$scope.currentSupport.schedule.startsOn,
      repeats: 'NONE',
      repeatsBy: 'NONE',
      repeatsEvery: 1,
      repeatsOn: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
    };
  }

  // Functions
  convertShorthandToWeekly = schedule => {
    schedule.repeats = schedule.repeats !== 'DAILY' && schedule.repeats !== 'MONTHLY' ? 'WEEKLY' : schedule.repeats;
  };

  confirmDialog = () => {
    this.$scope.hasBeenUpdatedBool = true;
    this.convertShorthandToWeekly(this.$scope.currentSupport.schedule);
    this.$scope.updatedRepeatValues = angular.copy(this.$scope.currentSupport.schedule);
    this.$mdDialog.hide();
  };

  cancelDialog = hasBeenUpdatedBool => {
    // if updated show that, if not show default
    this.$scope.currentSupport.schedule = hasBeenUpdatedBool
      ? angular.copy(this.$scope.updatedRepeatValues)
      : this.initialScheduleValues;
    this.$mdDialog.cancel();
  };

  // validate repeatsOn for WEEKLY interval
  validateRepeatDialog = schedule => {
    if (schedule.repeats === 'WEEKLY') {
      return !_.includes(schedule.repeatsOn, true) ? true : false;
    } else if (schedule.repeats === 'MONTHLY') {
      return schedule.repeatsBy === 'NONE' ? true : false;
    } else {
      return false;
    }
  };

  // set for backend:
  setRepeatsOnBools = schedule => {
    let repeatsOnObj = {
      // set to true
      WEEKLY: [],
      DAILY: [],
      MONTHLY: [],
      'EVERY WEEKDAY(M-F)': ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
      'EVERY M/W/F': ['monday', 'wednesday', 'friday'],
      'EVERY T/Th': ['tuesday', 'thursday'],
    };

    let repeatInterval = schedule.repeats;
    let allDays = _.keys(schedule.repeatsOn);
    let trueDays: any = _.get(repeatsOnObj, repeatInterval);

    schedule.repeatsEvery = trueDays.length > 1 ? 1 : schedule.repeatsEvery;
    schedule.repeatsBy = repeatInterval === 'MONTHLY' ? schedule.repeatsBy : 'NONE';

    _.forEach(allDays, function(day) {
      // start @ false:
      schedule.repeatsOn[day] = false;
    });

    _.forEach(trueDays, function(day) {
      // set correct days to true
      schedule.repeatsOn[day] = true;
    });

    return schedule;
  };
}

angular.module('nv.SupportsModule').controller('scheduleDialogCtrl', ScheduleDialogCtrl);
